import React from 'react';
// import { Router } from "@reach/router";

import { Switch, Route } from "react-router-dom";
import axios from 'axios';
import clientConfig from './client-config';

import LoginScreen from './screens/LoginScreen';
import StudentsList from './screens/StudentsList';
import SignUpNewStudent from './screens/SignUpNewStudent';

import BuildingInstructions from './screens/BuildingInstructions';
import ModelsPage from './screens/SingleProgram/ModelsPage';
import LessonsPage from './screens/SingleProgram/LessonsPage';
import SingleModelPage from './screens/SingleProgram/SingleModelPage';
import AdminAllTeachers from './screens/AdminAllTeachers';
import AdminAllStudents from './screens/AdminAllStudents';
import SignUpNewTeacher from './screens/SignUpNewTeacher'
import TermsOfUse from './screens/TermsOfUse';

import Lesson from './screens/fix2020/Lesson';
import SelectModel from './screens/fix2020/SelectModel';
import SelectModelLessonPlans from './screens/fix2020/SelectModelLessonPlans';
import LessonPlans from './screens/fix2020/LessonPlans';

import PasswordReset from './screens/PasswordReset';
import { StyleRoot } from 'radium';

import './App.css';

// Global axios interceptor to handle 401 responses (invalid/expired tokens)
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      // Token is invalid/expired, clear localStorage and redirect to login
      localStorage.clear();
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);


class App extends React.Component {
  componentDidMount() {
    // On startup, validate JWT via the auth plugin
    const token = localStorage.getItem('token');
    if (token) {
      const siteUrl = clientConfig.siteUrl;
      axios.post(
        `${siteUrl}/wp-json/jwt-auth/v1/token/validate`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      ).catch(err => {
        if (err.response && err.response.status === 403) {
          // Token invalid or expired, force logout
          localStorage.clear();
          window.location.href = '/';
        }
      });
    }
  }

  render() {
    return (

      <StyleRoot>
        <div className="AppContainer">

          <Switch>

            <Route path="/PasswordReset">
              <PasswordReset />
            </Route>


{/* FIX2020 */}
            <Route path="/select-model/:program/:id">
              <SelectModel />
            </Route>

            <Route path="/select-model-lesson-plans/:program/:id">
              <SelectModelLessonPlans />
            </Route>


            <Route path="/model_building_instructions/:programName/:ProgramId/:LessonsId">
              <Lesson />
            </Route>

{/* FIX2020 */}


            <Route path="/students_list/:userName/">
              <StudentsList />
            </Route>


            <Route path="/sign_up_new_student/:userName">
              <SignUpNewStudent />
            </Route>


            <Route exact path="/lesson_plans/:userName" >
              <LessonPlans />
            </Route>

            <Route path="/lesson_plans/:userName/:programName" >
              <LessonsPage />
            </Route>


            <Route exact path="/building_instructions/:userName" >
              <BuildingInstructions />
            </Route>


            <Route path="/building_instructions/:userName/:programName" >
              <ModelsPage />
            </Route>

            <Route path="/model_building_instructions/:userName/:programName/:ModelName">
              <SingleModelPage />
            </Route>





            <Route exact path="/">
              <LoginScreen />
            </Route>

          </Switch>


          <Route path="/admin/Franchise_Owners_List" >
            <AdminAllTeachers />
          </Route>

          <Route path="/admin/all_students_list" >
            <AdminAllStudents />
          </Route>

          <Route path="/admin/sign_up_new_franchise" >
            <SignUpNewTeacher />
          </Route>


          <Route path="/terms_of_use" >
            <TermsOfUse />
          </Route>

        </div>
      </StyleRoot>

    );
  }
}

export default App;







